import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import '../components/AboutUs.css'; // Applying consistent styles
const JobDetails = () => {
    const { jobId } = useParams();
    const [job, setJob] = useState(null);

    useEffect(() => {
        const storedJobs = JSON.parse(localStorage.getItem("adminJobs")) || [];
        const jobDetail = storedJobs.find(j => j.id === jobId);
        setJob(jobDetail);
    }, [jobId]);

    if (!job) {
        return <p className="text-center py-10">Loading job details...</p>;
    }

    return (
        <div className="container mx-auto py-10 px-4">
            <div className="bg-white p-6 rounded-lg shadow-md flex flex-col md:flex-row gap-8">
                {/* Left Section */}
                <div className="flex-1">
                    <h1 className="text-3xl font-bold text-blue-900 mb-4">{job.title}</h1>
                    <h2 className="text-xl font-semibold mb-2">Job Description</h2>
                    <p className="mb-4">{job.description}</p>
                    
                    <h2 className="text-xl font-semibold mb-2">Responsibilities</h2>
                    <ul className="list-disc ml-5 mb-4">
                        {job.responsibilities.map((item, index) => (
                            <li key={index}>{item}</li>
                        ))}
                    </ul>
                    
                    <h2 className="text-xl font-semibold mb-2">Requirements</h2>
                    <ul className="list-disc ml-5 mb-4">
                        {job.requirements.map((item, index) => (
                            <li key={index}>{item}</li>
                        ))}
                    </ul>
                </div>

                {/* Right Section */}
                <div className="w-full md:w-1/3 bg-gray-100 p-4 rounded-lg">
                    <h2 className="text-xl font-semibold mb-2">Job Details</h2>
                    <p className="text-gray-600 mb-2"><strong>Location:</strong> {job.location}</p>
                    <p className="text-gray-600 mb-2"><strong>Department:</strong> {job.department}</p>
                    <p className="text-gray-600 mb-2"><strong>Job Type:</strong> {job.jobType}</p>
                    <p className="text-gray-500 mb-4"><strong>Posted Date:</strong> {job.postedDate}</p>
                    
                    <h2 className="text-xl font-semibold mb-2">Benefits</h2>
                    <ul className="list-disc ml-5 mb-4">
                        {job.benefits.map((item, index) => (
                            <li key={index}>{item}</li>
                        ))}
                    </ul>
                </div>
            </div>
            <div className="mt-6 text-center">
                <button 
                    onClick={() => window.location.href = `mailto:recruit@ensuresap.com?subject=Job Application for ${job.title}`}
                    className="bg-blue-600 text-white px-6 py-2 rounded-lg shadow hover:bg-blue-700">
                    Apply Now
                </button>
            </div>
        </div>
    );
};

export default JobDetails;
